var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"clearable":_vm.clearable,"disabled":_vm.readonly,"value":_vm.value,"options":_vm.options,"reduce":obj => obj.code,"label":"value","clearSearchOnSelect":"","required":"","appendToBody":_vm.new_modal},on:{"input":_vm.handle_input}})
}
var staticRenderFns = []

export { render, staticRenderFns }